import React from 'react'
import './Air_button.css'

import { useNavigate } from 'react-router';

import { Translate } from '../Translate/Translate';

export const Air_button = ({ title, img, background_btn, color_btn, navigate_ }) => {

    const navigate = useNavigate()
    return (
        <button onClick={() => navigate(`${navigate_}`)} type='button' className='d-flex h-[50px] flex flex-row justify-center items-center text-center' style={{ background: `${background_btn}`, color: `${color_btn}`, position:'relative', padding:'8px 18px', minWidth:'187px', textAlign:'center' }}>
            <div className='image'>
                <img src={img} alt="" />
            </div>
            <div className='leading-4'>
                <Translate title={title} />
            </div>
        </button>
    )
}